import { render } from "./global-header.vue?vue&type=template&id=3e494058&scoped=true&ts=true"
import script from "./global-header.vue?vue&type=script&lang=ts"
export * from "./global-header.vue?vue&type=script&lang=ts"

import "./global-header.vue?vue&type=style&index=0&id=3e494058&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2602801780/src/biomass-frontend-poc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e494058"]])

export default __exports__